import React from 'react';
import s from './FormGroup.scss';
import { tooltips } from '../../../tooltips';
import Tooltip from 'rc-tooltip';
import Help from '../../../assets/images/icons/help-circle.svg';
import Info from '../../../assets/images/icons/Info.svg';
import { abtest } from '../../../utils';

const ErrorsManager = (errors, name) => {
    if(name == 'radio'){
        if(errors[0].includes('valid boolean') || errors[0].includes('no puede ser nulo') || errors[0].includes('no puede estar en blanco') ||  errors[0].includes('no es una elección válida')){
            return errors[0] = '¡Ups! Te faltó seleccionar una opción.';
        }
    }else{
        if(!!errors[0].key){
            if(errors[0].key.includes('no puede ser nulo')) '¡Ups! Te faltó completar este dato.';
        }else{
            if(errors[0].includes('no puede ser nulo')) '¡Ups! Te faltó completar este dato.';
        };
    };
    return errors[0];
};

const FormGroup = ({ label, errors, children, smooth, className = '', tooltipDesc, tooltip, name, flexButton, cross, abtestData, text, category}) => {
    return (
        <div className={`${s.formGroup} ${smooth ? s.smooth : ''} ${category ? s.categoryForm : ''} ${className}`} style={{width: category && 'fit-content'}}>
            <label className={`${s.label} ${category ? s.categoryLabel : ''}`} htmlFor=''>{label}
                <span>
                    {tooltip && <Tooltip destroyTooltipOnHide placement="bottom" trigger={['click', 'hover']} overlayStyle={{ maxWidth: '300px', display: 'inline-block'}} overlay={tooltips[tooltipDesc].map(({ description }) => [description])}>
                        <img className={s.helpImg} src={Help} alt="icono de ayuda"></img>
                    </Tooltip>}
                </span>
            </label>
              {cross ?
                 <div className={s.crosseling}>
                    <img style={{height: '20px'}} src={Info} alt='icono de informacion'/>
                    <p className={s.textCross}>{`El monto máximo en este tipo de ${abtest(abtestData && abtestData)} es de $350.000 y podemos prestarte `}<b>hasta el 40% del valor</b> del auto.</p>
                 </div>
                 :
                 <p className={s.text}>{text}</p>
              }
            <div className={`${s.children} ${flexButton ? s.flexButton : ''} ${category ?  s.categoryButtons : '' }`}>{children}</div>
            {errors && <p autoFocus className={s.error}>{ErrorsManager(errors, name)}</p>}
        </div>
    );
}

export default FormGroup;
